import React from 'react'

function Title({titleh1 , titleh2}) {
  return (
    <div className='my-40'>
    <h1 className='font-primary font-bold text-6xl flex justify-center text-[#D5FF3C]' data-aos="zoom-in-down">{titleh1}</h1>
    <h2 className='font-bold text-4xl flex justify-center py-5 text-yellow-100' data-aos="zoom-in-down">{titleh2}</h2>
    </div>  )
}

export default Title